import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import relativeTime from 'dayjs/plugin/relativeTime';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/en';
import 'dayjs/locale/uk';
import 'dayjs/locale/ru';

import { toDayjsLocale } from '../constants/locales';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
dayjs.extend(relativeTime);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(updateLocale);

dayjs.updateLocale('uk', { weekStart: 1 });
dayjs.updateLocale('ru', { weekStart: 1 });

dayjs.tz.setDefault('Europe/Kiev');

export const setDayjsLocale = (i18nLocale: string): void => {
    dayjs.locale(toDayjsLocale(i18nLocale));
};

export default dayjs;